import React, { useContext } from "react";
import { Text, BlockStack, InlineStack } from "@shopify/polaris";
import ClickReserve from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";

const HybridClickReserve = () => {
  const { cms } = useContext(FulfillmentContext);
  return (
    <div className="hybridClickReserve">
      <BlockStack gap="10">
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {cms("hybrid.clickReserve.title")}
          </Text>
          <br />
          <Text as="span" tone="subdued">
            {cms("hybrid.clickReserve.description")}
          </Text>
        </InlineStack>
      </BlockStack>
      <br />
      <ClickReserve method="hybridClickReserve" />
    </div>
  );
};

export default HybridClickReserve;
